export default {"src":"/_next/static/media/join_the_discord.b3689aaf.svg","height":220,"width":755,"blurWidth":0,"blurHeight":0};